import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { api } from '../api/client';

type Obra = {
  id: number;
  titulo: string;
  descripcion: string | null;
  ubicacion: string | null;
  area: string | null;
  estado: 'en_ejecucion' | 'planificada' | 'suspendida' | 'finalizada';
  avance: number;
  fecha_inicio: string | null;
  fecha_fin_est: string | null;
  imagen_portada: string | null;
};

const ESTADO_LABEL: Record<string, string> = {
  en_ejecucion: 'En ejecución',
  planificada:  'Planificada',
  suspendida:   'Suspendida',
  finalizada:   'Finalizada',
};
const ESTADO_COLOR: Record<string, string> = {
  en_ejecucion: '#10b981',
  planificada:  '#3b82f6',
  suspendida:   '#f59e0b',
  finalizada:   '#6b7280',
};

export default function Obras() {
  const nav = useNavigate();
  const [items, setItems]     = useState<Obra[]>([]);
  const [cargando, setCargando] = useState(true);
  const [err, setErr]         = useState<string | null>(null);

  useEffect(() => {
    api<{ items: Obra[] }>('/obras')
      .then((d) => setItems(d.items))
      .catch((e) => setErr(e.message))
      .finally(() => setCargando(false));
  }, []);

  return (
    <>
      <TopBar title="Tablero de obras" back />
      <main className="max-w-md mx-auto px-4 py-4 pb-24 space-y-3">
        {cargando && <p className="text-center text-gray-400 pt-10">Cargando…</p>}
        {err && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3">{err}</div>
        )}
        {!cargando && items.length === 0 && (
          <div className="text-center py-14">
            <p className="text-4xl mb-3">🏗️</p>
            <p className="text-gray-500 text-sm">No hay obras registradas.</p>
          </div>
        )}
        {items.map((o) => {
          const color = ESTADO_COLOR[o.estado] ?? '#6b7280';
          return (
            <button
              key={o.id}
              onClick={() => nav(`/obras/${o.id}`)}
              className="w-full text-left bg-white border border-app rounded-xl overflow-hidden shadow-sm active:bg-gray-50"
            >
              {o.imagen_portada && (
                <img
                  src={`/ciudadapp/uploads/obras/${o.imagen_portada}`}
                  alt=""
                  className="w-full object-cover"
                  style={{ height: 130 }}
                />
              )}
              <div className="px-4 py-3 space-y-2.5">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-base text-gray-900 leading-snug">{o.titulo}</p>
                    {o.ubicacion && (
                      <p className="text-xs text-gray-500 mt-0.5">📍 {o.ubicacion}</p>
                    )}
                  </div>
                  <span
                    className="text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0 mt-0.5"
                    style={{ backgroundColor: color + '20', color }}
                  >
                    {ESTADO_LABEL[o.estado] ?? o.estado}
                  </span>
                </div>
                <div>
                  <div className="flex justify-between text-xs mb-1">
                    <span className="text-gray-400">Avance</span>
                    <span className="font-bold text-gray-700">{o.avance}%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden">
                    <div
                      className="h-2 rounded-full transition-all"
                      style={{ width: `${o.avance}%`, backgroundColor: color }}
                    />
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </main>
    </>
  );
}
